import React from 'react';
import PropTypes from 'prop-types';
import { env } from 'src/config/env';
import { Divider, Icon } from '@unite-us/app-components';
import {
  useFind,
} from 'src/api/APIHooks';

const ConsentFileSection = ({ referral }) => {
  const consents = referral?.custom_consents?.map((consent) => consent.id).join(',');
  const { data: customConsents } = useFind(
    `people/${referral?.case?.person?.id}/custom_consents`,
    { id: consents },
    { queryConfig: { enabled: !!referral?.custom_consents, placeholderData: undefined } },
  );
  const customConsentsAccepted = customConsents?.data?.data?.reduce((prev, c) => prev && c.state === 'accepted', true);

  const { data: fileUploadsData } = useFind(
    'file_upload',
    {
      'record.type': 'custom_consent',
      record: consents,
    },
    {
      queryConfig:
        {
          enabled: !!referral?.custom_consents?.length && customConsentsAccepted,
          placeholderData: undefined,
        },
    },
  );

  const fileUploads = fileUploadsData?.data?.data;

  const fileUrl = fileUploads?.[0]?.path && `${env.CORE_BASE_URL}${fileUploads[0].path}`;

  if (!fileUrl || !customConsentsAccepted) {
    return null;
  }

  return (
    <>
      <Divider className="detail-info__horizontal-divider mb-4 mt-4" />
      <h5 data-testid="consent-file-section-title" className="mb-2">
        REFERRAL CONSENT
      </h5>
      <a
        href={fileUrl}
        target="_blank"
        rel="noreferrer"
        className="text-action-blue"
      >
        View Consent <Icon color={'action-blue'} className="ml-2" icon="ExternalLink" />
      </a>
    </>
  );
};

ConsentFileSection.propTypes = {
  referral: PropTypes.shape({
    custom_consents: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
    })),
    case: PropTypes.shape({
      person: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default ConsentFileSection;
